import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { useSelector } from 'react-redux';

const Theme = props => {
	const mainTheme = useSelector(({ fuse }) => fuse.settings.mainTheme);
	return <ThemeProvider theme={mainTheme}>{props.children}</ThemeProvider>;
};

export default React.memo(Theme);
